import React,{useEffect} from 'react';
import { Card, CardContent, CardMedia, Typography, Box, Tooltip } from '@mui/material';
import { Web, Storage, MobileFriendly, AccountTree, BuildCircle, People, Leaderboard, Sms } from '@mui/icons-material'; 
import { Swiper, SwiperSlide } from 'swiper/react';
import Grid from '@mui/material/Grid2';
import 'swiper/css';
import 'swiper/css/navigation';
import '../styles.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useTranslation } from 'react-i18next';

import { Autoplay, Navigation, Pagination } from 'swiper/modules';

const SkillsSection = () => {
  const { t } = useTranslation();

   useEffect(() => {
        AOS.init({ duration: 1000 });
      }, []);
  

      const skills = [
        {
          title: t('skillsSection.webDevelopment'),
          description: t('descriptions.webDevelopment'),
          icon: <Web fontSize="inherit" sx={{ fontSize: 70 }} />,
        },
        {
          title: t('skillsSection.databaseManagement'),
          description: t('descriptions.databaseManagement'),
          icon: <Storage fontSize="inherit" sx={{ fontSize: 70 }} />,
        },
        {
          title: t('skillsSection.teamwork'),
          description: t('descriptions.teamwork'),
          icon: <People fontSize="inherit" sx={{ fontSize: 70 }} />,
        },
        {
          title: t('skillsSection.leadership'),
          description: t('descriptions.leadership'),
          icon: <Leaderboard fontSize="inherit" sx={{ fontSize: 70 }} />,
        },
        {
          title: t('skillsSection.mobileDevelopment'),
          description: t('descriptions.mobileDevelopment'),
          icon: <MobileFriendly fontSize="inherit" sx={{ fontSize: 70 }} />,
        },
        {
          title: t('skillsSection.projectManagement'),
          description: t('descriptions.projectManagement'),
          icon: <AccountTree fontSize="inherit" sx={{ fontSize: 70 }} />,
        },
        {
          title: t('skillsSection.backendDevelopment'),
          description: t('descriptions.backendDevelopment'),
          icon: <BuildCircle fontSize="inherit" sx={{ fontSize: 70 }} />,
        },
        {
          title: t('skillsSection.effectiveCommunication'),
          description: t('descriptions.effectiveCommunication'),
          icon: <Sms fontSize="inherit" sx={{ fontSize: 70 }} />,
        },
      ];

  const iconPaths = [
    '/assets/icons/javascript-original.svg',
    '/assets/icons/typescript-original.svg',
    '/assets/icons/python-original.svg',
    '/assets/icons/java-original.svg',
    '/assets/icons/cplusplus-original.svg',
    '/assets/icons/csharp-original.svg',
    '/assets/icons/react-original.svg',
    '/assets/icons/angular-original.svg',
    '/assets/icons/flutter-original.svg',
    '/assets/icons/nodejs-original.svg',
    '/assets/icons/dot-net-original.svg',
    '/assets/icons/laravel-original.svg',
    '/assets/icons/microsoftsqlserver-original.svg',
    '/assets/icons/mysql-original.svg',
    '/assets/icons/postgresql-original.svg',
    '/assets/icons/firebase-original.svg',
    '/assets/icons/azuredevops-original.svg',
    '/assets/icons/github-original.svg',
  ];

  const iconNames = [
    'JavaScript', 'TypeScript', 'Python', 'Java', 'C++', 'C#', 
    'React', 'Angular', 'Flutter', 'Node.js', '.NET', 'Laravel', 
    'SQL Server', 'MySQL', 'PostgreSQL', 'Firebase', 'Azure DevOps', 'GitHub'
  ];

  return (
    <section id="skills" className="skills-section"    >
      <div className="container" data-aos="fade-up">
        <h1>{t('skillsSection.title')}</h1>
        <p className= "subtitle" style={{ color: 'white'}}>
          {t('skillsSection.description')}
        </p>
        <div className="carousel-container">
          <Swiper
            modules={[Navigation, Autoplay, Pagination]}
            spaceBetween={60}
            slidesPerView={3}
            pagination={false}
            breakpoints={{
              240: { slidesPerView: 1 },
              640: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            className="skills-carousel"
            navigation
            speed={1000}
            autoplay={{
              delay: 3500,
              disableOnInteraction: false,
            }}
          >
            {skills.map((skill, index) => (
              <SwiperSlide key={index}>
                <Card className="skills-card">
                  <CardMedia className="skills-icon">
                    <div className="skill-icon-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '120px' }}>
                      {skill.icon}
                    </div>
                  </CardMedia>
                  <CardContent className="skills-content">
                    <Typography variant="h6" color="orange" fontWeight="bold">
                      {skill.title}
                    </Typography>
                    <Typography variant="body2" color="white">
                      {skill.description}
                    </Typography>
                  </CardContent>
                </Card>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
         {/* Contenedor para los iconos desde la carpeta public/assets/icons */}
         <Box data-aos="fade-up" sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Grid container spacing={2} justifyContent="center" className="grid-container" sx={{paddingInline:{xs:0, sm:2, md: 2}}}>
            {iconPaths.map((iconPath, index) => (
              <Grid size={{xs: 3, sm: 2, md: 1}} key={index}>
                <Tooltip title={iconNames[index]} placement="top" 
                 slotProps={{
                  popper: {
                    modifiers: [
                      {
                        name: 'offset',
                        options: {
                          offset: [0, 10], 
                        },
                      },
                    ],
                  },
                  tooltip: {
                    sx: {
                      fontSize: '1.2rem', 
                      fontWeight: 'bold',
                    },
                  },
                }}
                >
                  <div className="icon-container">
                    <img 
                      src={iconPath} 
                      alt={iconNames[index]} 
                      style={{ 
                        width: '100%', 
                        height: '100%', 
                        objectFit: 'cover'  
                      }} 
                    />
                  </div>
                </Tooltip>
              </Grid>
            ))}
          </Grid>
        </Box>
      </div>
    </section>
  );
};

export default SkillsSection;
